"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccount = void 0;
const constants_1 = require("../utils/constants");
function useAccount() {
    const account = window.localStorage.getItem(constants_1.TRIA_WALLET_STORE);
    return { account: JSON.parse(account) };
}
exports.useAccount = useAccount;
